import {
  IStyle,
  mergeStyleSets,
  IProcessedStyleSet
} from 'office-ui-fabric-react';

export interface LoadingSpinnerStyles {
  container: IStyle;
}

export const getLoadingSpinnerStyles = (): IProcessedStyleSet<LoadingSpinnerStyles> => {
  const styles: LoadingSpinnerStyles = {
    container: {
      marginTop: '60px',
      display: 'flex',
      justifyContent: 'center',
      width: '100%'
    }
  };

  return mergeStyleSets(styles);
};
